require("!!/home/runner/work/jb-webapp/jb-webapp/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/jb-webapp/jb-webapp/node_modules/raw-loader/index.js!/home/runner/work/jb-webapp/jb-webapp/src/js/vendor/jsPlumb-2.0.6.js"))


//////////////////
// WEBPACK FOOTER
// ../~/script-loader!./js/vendor/jsPlumb-2.0.6.js
// module id = 145
// module chunks = 5